import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68c5cca9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification-text-block" }
const _hoisted_2 = { class: "notification-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Notification = _resolveComponent("Notification")!
  const _directive_focus_trap = _resolveDirective("focus-trap")!

  return (_ctx.showNotification)
    ? _withDirectives((_openBlock(), _createBlock(_component_Notification, {
        key: 0,
        class: _normalizeClass(["notification-block", _ctx.notificationClasses]),
        mode: "error"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_Icon, {
              name: _ctx.notificationContent.iconName,
              width: _ctx.notificationContent.iconSize,
              height: _ctx.notificationContent.iconSize,
              color: _ctx.notificationContent.iconColor
            }, null, 8, ["name", "width", "height", "color"]),
            _createElementVNode("div", {
              class: _normalizeClass({'text-gap': !_ctx.settings.minimize})
            }, [
              _createVNode(_component_Typography, {
                style: {"font-weight":"500"},
                fontSize: "16px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.notificationContent.title), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_2, [
                (_ctx.notificationContent.showSpinner)
                  ? (_openBlock(), _createBlock(_component_Spinner, {
                      key: 0,
                      size: "m"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.notificationState === 'pauseCallEnded')
                  ? (_openBlock(), _createBlock(_component_Typography, {
                      key: 1,
                      fontSize: "16px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('pauseCallEnded.text') +  ` ${_ctx.NotificationContent.pauseCallEnded.number} ` + _ctx.t('pauseCallEnded.text_2')), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_Typography, {
                      key: 2,
                      fontSize: "16px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.notificationContent.text), 1)
                      ]),
                      _: 1
                    }))
              ])
            ], 2)
          ]),
          (_ctx.notificationContent.showButton)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "leave-btn",
                size: "m",
                mode: _ctx.notificationContent.buttonMode,
                icon: _ctx.notificationContent.buttonIcon,
                iconOnly: !_ctx.buttonText,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.notificationContent.buttonAction()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
                ]),
                _: 1
              }, 8, ["mode", "icon", "iconOnly"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"])), [
        [_directive_focus_trap, _ctx.showNotification]
      ])
    : _createCommentVNode("", true)
}